module.exports = __webpack_public_path__ + "static/img/Freewheel-AM-Default.1b3f9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Freewheel-AM-Default.png
// module id = 1588
// module chunks = 0